import { render, staticRenderFns } from "./TenantUserEditor.vue?vue&type=template&id=51cbb4b8&scoped=true&lang=pug"
import script from "./TenantUserEditor.vue?vue&type=script&lang=ts"
export * from "./TenantUserEditor.vue?vue&type=script&lang=ts"
import style0 from "./TenantUserEditor.vue?vue&type=style&index=0&id=51cbb4b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cbb4b8",
  null
  
)

export default component.exports